export default "__VITE_ASSET__Clys$aAs__"